import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React from "react";
import { FiMoreHorizontal } from "react-icons/fi";
import { useSelector } from "react-redux";
import { getEnrollees } from "../../../store/enrollee";
import { getFormatedDate } from "../../../utils/constants";
import AppMenu from "../../menu";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  tableRow: {
    "& th": {
      color: "#E6072C",
      whiteSpace: "nowrap",
    },
  },

  pending: {
    color: "#FFA800",
    backgroundColor: "#FDF7EB",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
  approved: {
    color: "#25B273",
    backgroundColor: "#E3F9F1",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
  declined: {
    color: "#8B8888",
    backgroundColor: "rgba(139, 136, 136, 0.1)",
    borderRadius: "10px",
    padding: "5px 15px",
    textTransform: "capitalize",
  },
});

const DrugRefill = ({ onShowDrugRefillDetails }) => {
  const classes = useStyles();
  const enrollees = useSelector(getEnrollees);
  const drugRequestHistory = enrollees.data
    ? enrollees.data.drug_refill_requests_history
    : [];

  return drugRequestHistory.length === 0 ? (
    <div className="text-center font-bold">No Drug History</div>
  ) : (
    <Table className={classes.table} aria-label="simple table">
      <TableHead>
        <TableRow className={classes.tableRow}>
          <TableCell>Medication Name</TableCell>
          <TableCell align="left">Request Reason</TableCell>
          <TableCell align="left">Request Date</TableCell>
          <TableCell align="left">Request Status</TableCell>
          <TableCell />
        </TableRow>
      </TableHead>
      <TableBody>
        {drugRequestHistory.map((row) => (
          <TableRow key={row.id}>
            <TableCell component="th" scope="row">
              {row.drug_name}
            </TableCell>
            <TableCell align="left">{row.reason}</TableCell>
            <TableCell align="left">
              {getFormatedDate(row.created_at)}
            </TableCell>
            <TableCell align="left">
              <span className={classes[row.status]}>{row.status}</span>
            </TableCell>
            <TableCell align="center">
              <AppMenu
                menu_name_or_icon={
                  <button>
                    <FiMoreHorizontal size="1.3em" color="#A8A8A8" />
                  </button>
                }
                item_names={[
                  {
                    "View Details": () =>
                      onShowDrugRefillDetails(true, row.id, "drug-refill"),
                  },
                ]}
              />
              {/* <button>
              </button> */}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default DrugRefill;
